import PropTypes from "prop-types";
/**
 * Created by fers on 25.02.16.
 */

import Relay from 'react-relay';

interface ResendInvitationMutationProps {
  invitation?: any;
}

export default class ResendInvitationMutation extends Relay.Mutation<ResendInvitationMutationProps> {
  static propTypes = {
    invitation: PropTypes.any
  };
  static fragments = {
    invitation: () => Relay.QL`
              fragment on Invitation {
                    organisation_id,
                    id,
              }
            `
  };
  getMutation() {
    return Relay.QL`mutation {resendInvitation}`;
  }
  getFatQuery() {
    return Relay.QL`
            fragment on ResendInvitationPayload {
                success
            }
        `;
  }
  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {}
    }];
  }
  getVariables() {
    return {
      invitation_id: this.props.invitation.id,
      organisation_id: this.props.invitation.organisation_id
    };
  }
}